import { useContext } from "react"
import intl from "react-intl-universal"

import PaineisContext from "../contexts/Paineis"
import EditIcon from "../assets/icons/EditIcon"
import TrashIcon from "../assets/icons/TrashIcon"

const usePanelMenu = (oCurrentPanel) => {
    const {
        fnSetOCurrentPanel,
        fnSetBIsOpenAddPanel,
        fnSetBIsEditPanel,
        fnSetBIsOpenDeleteWarningPanel,
        fnSetBIsOpenDeleteAlertPanel,
        fnGetBoardsReq,
    } = useContext(PaineisContext)

    function fnHandleSetCurrentPanel() {
        if (oCurrentPanel) fnSetOCurrentPanel(oCurrentPanel)
    }

    function fnOpenEditPanel() {
        fnHandleSetCurrentPanel()
        fnSetBIsOpenAddPanel(true)
        fnSetBIsEditPanel(true)
    }

    async function fnOpenDeletePanel() {
        fnSetBIsOpenDeleteAlertPanel(true)
        fnHandleSetCurrentPanel()

        const response = await fnGetBoardsReq(oCurrentPanel?.id)
        const bHasBoards = response?.data?.data?.length > 0

        if (!bHasBoards) {
            fnSetBIsOpenDeleteAlertPanel(false)
            fnSetBIsOpenDeleteWarningPanel(true)
        }
    }

    const aPanelMenuOptions = [
        {
            label: intl.get("DashboardPage.edit_panel"),
            icon: <EditIcon />,
            onClick: fnOpenEditPanel,
        },
        {
            label: intl.get("DashboardPage.delete_panel"),
            icon: <TrashIcon fill="#6CB6E3" />,
            onClick: fnOpenDeletePanel,
        },
    ]

    return aPanelMenuOptions
}

export default usePanelMenu